module.exports = __webpack_public_path__ + "img/sethis.24a0056f.jpg";